enum FrequencyAtLocationEnum {
  None = "None",
  PatientsDayInMonth = "patients_day_in_month",
  PatientsDayInWeek = "patients_day_in_week",
  PatientsInfrequently = "patients_infrequently",
  PatientsNever = "patients_never",
  SubstituteForColleague = "substitute_for_colleague",
}

export { FrequencyAtLocationEnum };
